import React, { useEffect, useRef } from "react";
import { generateSunburstSvgESG } from "./sunBurstSvgESG";
import { mapRecursive, roundDecimal } from "../../../utils";
import "./SunBurstChart.scss";
import { setDashboardSelectedGrouping, useDashboardSelectedGrouping } from "../../../hooks/project";
import { useTranslation } from "react-i18next";

export const SunBurstChartESG = ({ data }) => {
  const { i18n } = useTranslation();
  const chartRef = useRef(null);
  const middleRef = useRef(null);
  const selectedGrouping = useDashboardSelectedGrouping();

  const { groupingElements, superScore, potentialSuperScore } = (data || {});
  const groupings = groupingElements || [];

  useEffect(() => {
    if (chartRef && chartRef.current) {
      chartRef.current.innerHTML = '';
      if (groupings && groupings.length) {
        const processed = {
          children: mapRecursive(groupings, (node, children) => {
            const universalScore = roundDecimal(node.universalScore, 100);
            let potentialScore = roundDecimal(node.potentialUniversalScore, 100);

            return {
              uuid: node.uuid,
              value: node.maxSystemScoreProportion,
              kpis: node.indicatorElements?.map(item => item.kpi).filter(item => !!item),
              universalScore: universalScore,
              potentialScore: potentialScore > universalScore ? potentialScore : universalScore,
              title: node.name,
              type: node.type,
              children
            };
          }, 'groupingElements')
        };

        const overallSuperScore = roundDecimal(superScore, 100);
        chartRef.current.appendChild(generateSunburstSvgESG({
          data: processed,
          value: selectedGrouping,
          onSelect: setDashboardSelectedGrouping,
          superScore: overallSuperScore,
          middleContent: middleRef.current,
          potentialSuperScore: (potentialSuperScore && potentialSuperScore > overallSuperScore)
            ? roundDecimal(potentialSuperScore, 100)
            : overallSuperScore
        }));
      }
    }
  }, [groupings, selectedGrouping, chartRef]);

  return (
    <div className="sun-burst-chart">
      <div ref={chartRef} className="chart"/>
      <div ref={middleRef} className="middle-content">
        <div className="header-text text-hyphens" lang={i18n.language}/>
        <div className="value-text"/>
        <div className="potential-text"/>
      </div>
    </div>
  );
};
